import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import { axiosReq } from "../../commons/axiosReq";
import User from "../../assets/icon/NewsIcons/MainAdmin/NewsPerson";
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch";
import Delete from "../../assets/icon/NewsIcons/MainAdmin/NewsDelete";
import Cross from "../../assets/icon/NewsIcons/MainAdmin/NewsCross";
import { ReactComponent as Right } from "../../assets/icon/right.svg";
import { ReactComponent as Left } from "../../assets/icon/left.svg";

const MainAdminCollegeField = () => {
    const { collegeFieldId } = useParams();
    const { state } = useLocation();
    const navigate = useNavigate();
    const id = Number(collegeFieldId || state?.id);

    const [teachers, setTeachers] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [refreshKey, setRefreshKey] = useState(0);
    const [showAddModal, setShowAddModal] = useState(false);
    const [availableTeachers, setAvailableTeachers] = useState([]);
    const [selectedTeacherId, setSelectedTeacherId] = useState("");
    const [addLoading, setAddLoading] = useState(false);
    const [addError, setAddError] = useState("");

    useEffect(() => {
        if (!new Cookies().get("token")) {
            navigate("/SignIn", { replace: true });
            return;
        }

        if (!Number.isInteger(id) || id <= 0) {
            setLoading(false);
            setError("رشتهٔ دانشکده انتخاب نشده است. لطفاً از صفحهٔ رشته‌های دانشکده وارد جزئیات شوید.");
            return;
        }

        let cancelled = false;
        const getData = async () => {
            setLoading(true);
            setError("");
            const response = await axiosReq(
                `CollegeFieldTeacher/GetCollegeFieldTeachersByCollegeField?page=${page}&pageSize=${row}&search=${encodeURIComponent(search)}`,
                "post",
                { id }
            );

            if (cancelled) return;
            if (!response || response.status < 200 || response.status >= 300) {
                setTeachers([]);
                setCount(0);
                setError("دریافت فهرست استادها با خطا روبه‌رو شد. دوباره تلاش کنید.");
            } else {
                const result = response.data;
                setTeachers(Array.isArray(result?.data) ? result.data : Array.isArray(result) ? result : []);
                setCount(Number(result?.count ?? result?.length ?? 0));
            }
            setLoading(false);
        };

        getData();
        return () => { cancelled = true; };
    }, [id, navigate, page, refreshKey, row, search]);

    const removeTeacher = async (item) => {
        if (!window.confirm(`ارتباط ${item?.teacher?.name || "این استاد"} با این رشته حذف شود؟`)) return;
        const response = await axiosReq(
            `CollegeFieldTeacher/DeleteCollegeFieldTeacher/${item.collegeFieldTeacherId}`,
            "delete"
        );
        if (response?.status >= 200 && response?.status < 300) {
            if (teachers.length === 1 && page > 1) setPage((value) => value - 1);
            else setRefreshKey((value) => value + 1);
            return;
        }
        setError("حذف ارتباط استاد با این رشته انجام نشد.");
    };

    const openAddModal = async () => {
        setShowAddModal(true);
        setAddLoading(true);
        setAddError("");
        setSelectedTeacherId("");

        const [allTeachers, relationsResponse] = await Promise.all([
            axiosReq("Teacher/GetTeachers", "get"),
            axiosReq("CollegeFieldTeacher/GetCollegeFieldTeachersByCollegeField", "post", { id })
        ]);
        const relations = relationsResponse?.status >= 200 && relationsResponse?.status < 300
            ? relationsResponse.data
            : [];
        const assignedTeacherIds = new Set(
            (Array.isArray(relations) ? relations : relations?.data || []).map((item) => item.teacherId)
        );

        if (!Array.isArray(allTeachers)) {
            setAvailableTeachers([]);
            setAddError("دریافت فهرست استادها انجام نشد.");
        } else {
            setAvailableTeachers(allTeachers.filter((teacher) => !assignedTeacherIds.has(teacher.teacherId)));
        }
        setAddLoading(false);
    };

    const addTeacher = async () => {
        const teacherId = Number(selectedTeacherId);
        if (!Number.isInteger(teacherId) || teacherId <= 0) {
            setAddError("لطفاً یک استاد را انتخاب کنید.");
            return;
        }

        setAddLoading(true);
        setAddError("");
        const response = await axiosReq("CollegeFieldTeacher/InsertCollegeFieldTeacher", "post", {
            collegeFieldId: id,
            teacherId
        });
        if (response?.status >= 200 && response?.status < 300) {
            setShowAddModal(false);
            setPage(1);
            setRefreshKey((value) => value + 1);
        } else {
            setAddError(typeof response?.data === "string" ? response.data : "ثبت استاد برای این رشته انجام نشد.");
        }
        setAddLoading(false);
    };

    const from = count === 0 ? 0 : ((page - 1) * row) + 1;
    const to = Math.min(page * row, count);

    return (
        <div>
            <div className="p-[20px] flex flex-wrap gap-4 justify-between items-center border-b-2 border-borderGray">
                <div className="flex justify-start items-center">
                    <div><User color="black" /></div>
                    <p className="font-IRANYekanExtra text-[15px] mr-[15px]">استادهای رشتهٔ دانشکده</p>
                </div>
                <div className="flex flex-wrap gap-3 items-center">
                    <div className="w-[238px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center">
                        <input
                            value={search}
                            onChange={(event) => { setSearch(event.target.value); setPage(1); }}
                            className="w-full font-IRANYekanNormal focus:outline-none placeholder-lightGray"
                            type="text"
                            placeholder="جستجوی استاد..."
                        />
                        <Search />
                    </div>
                    <button
                        onClick={openAddModal}
                        disabled={!Number.isInteger(id) || id <= 0}
                        className="h-[40px] min-w-[154px] px-4 bg-infinity-gradient shadow-norm-shadow rounded-[10px] flex justify-center items-center disabled:opacity-50"
                    >
                        <span className="font-IRANYekanLight text-[28px] text-white leading-none">+</span>
                        <span className="font-IRANYekanBold text-[14px] text-white mr-[7px]">افزودن استاد</span>
                    </button>
                </div>
            </div>

            <div className="pt-[20px] px-[20px] pb-[80px]">
                {error && <div className="mb-4 rounded-[10px] bg-red-50 p-4 text-sm text-red-700 font-IRANYekanMedium">{error}</div>}
                <div className="rounded-[15px] pt-[15px] px-[15px] pb-[30px] border-borderGray border-2 w-full overflow-auto">
                    <table className="w-full min-w-[650px]">
                        <thead>
                            <tr className="h-[60px] w-full bg-lightBlue2">
                                <th className="rounded-r-[15px] text-right pr-[17px] text-[15px] font-IRANYekanBold text-mainColor2">ردیف</th>
                                <th className="text-right text-[15px] font-IRANYekanBold text-mainColor2">نام</th>
                                <th className="text-right text-[15px] font-IRANYekanBold text-mainColor2">نام خانوادگی</th>
                                <th className="text-right text-[15px] font-IRANYekanBold text-mainColor2">ایمیل</th>
                                <th className="rounded-l-[15px] text-center pl-[17px] text-[15px] font-IRANYekanBold text-mainColor2">عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading && teachers.map((item, index) => (
                                <tr key={item.collegeFieldTeacherId} className="h-[56px] w-full border-b-2 border-borderGray">
                                    <td className="text-[15px] text-right pr-[17px] font-IRANYekanBold">{index + from}</td>
                                    <td className="text-[15px] text-right font-IRANYekanBold">{item?.teacher?.name || "—"}</td>
                                    <td className="text-[15px] text-right font-IRANYekanBold">{item?.teacher?.family || "—"}</td>
                                    <td className="text-[15px] text-right font-IRANYekanBold" dir="ltr">{item?.teacher?.email || "—"}</td>
                                    <td className="text-center">
                                        <button onClick={() => removeTeacher(item)} aria-label="حذف ارتباط استاد"><Delete /></button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {loading && <p className="py-12 text-center font-IRANYekanMedium text-lightGray">در حال دریافت اطلاعات...</p>}
                    {!loading && !error && teachers.length === 0 && <p className="py-12 text-center font-IRANYekanMedium text-lightGray">استادی برای این رشته ثبت نشده است.</p>}

                    <div className="w-full py-3 px-3 flex items-center justify-between font-IRANYekanMedium">
                        <div className="flex items-center">
                            <p className="text-sm text-right px-4">تعداد ردیف در هر صفحه:</p>
                            <select value={row} onChange={(event) => { setRow(Number(event.target.value)); setPage(1); }} className="bg-white border border-gray-300 text-sm rounded-md px-2 py-1">
                                <option value={5}>۵</option>
                                <option value={10}>۱۰</option>
                                <option value={25}>۲۵</option>
                            </select>
                        </div>
                        <div className="flex items-center">
                            <p className="text-sm px-4">{from}-{to} از {count}</p>
                            <button onClick={() => setPage((value) => value + 1)} disabled={to >= count} className="mx-2 disabled:opacity-30"><Right /></button>
                            <button onClick={() => setPage((value) => value - 1)} disabled={page === 1} className="mx-2 disabled:opacity-30"><Left /></button>
                        </div>
                    </div>
                </div>
            </div>

            {showAddModal && (
                <>
                    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-4">
                        <div className="w-full max-w-xl rounded-[20px] bg-white p-[25px] shadow-lg">
                            <div className="flex justify-between items-center border-b-2 pb-[20px] border-borderGray">
                                <p className="text-[15px] font-IRANYekanBold text-mainColor2">افزودن استاد به رشته</p>
                                <button onClick={() => setShowAddModal(false)} aria-label="بستن"><Cross /></button>
                            </div>
                            <div className="mt-6">
                                <label htmlFor="teacherId" className="mb-2 block text-sm font-IRANYekanBold">استاد</label>
                                <select
                                    id="teacherId"
                                    value={selectedTeacherId}
                                    onChange={(event) => { setSelectedTeacherId(event.target.value); setAddError(""); }}
                                    disabled={addLoading || availableTeachers.length === 0}
                                    className="w-full rounded-[10px] border border-gray-300 bg-white p-3 font-IRANYekanMedium focus:border-mainColor focus:outline-none"
                                >
                                    <option value="">انتخاب کنید</option>
                                    {availableTeachers.map((teacher) => (
                                        <option key={teacher.teacherId} value={teacher.teacherId}>
                                            {teacher.name} {teacher.family} — {teacher.email}
                                        </option>
                                    ))}
                                </select>
                                {!addLoading && availableTeachers.length === 0 && !addError && (
                                    <p className="mt-2 text-sm font-IRANYekanMedium text-lightGray">همهٔ استادها قبلاً به این رشته اضافه شده‌اند.</p>
                                )}
                                {addError && <p className="mt-2 text-sm font-IRANYekanMedium text-red-600">{addError}</p>}
                            </div>
                            <div className="mt-8 flex justify-end gap-3">
                                <button onClick={() => setShowAddModal(false)} className="h-[40px] px-5 font-IRANYekanBold">بستن</button>
                                <button
                                    onClick={addTeacher}
                                    disabled={addLoading || availableTeachers.length === 0}
                                    className="h-[40px] min-w-[107px] rounded-[10px] bg-infinity-gradient px-5 text-white font-IRANYekanBold disabled:opacity-50"
                                >
                                    {addLoading ? "در حال ثبت..." : "ثبت"}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="fixed inset-0 z-40 bg-black opacity-25" />
                </>
            )}
        </div>
    );
};

export default MainAdminCollegeField;
